import { React, useEffect, useState } from 'react';
import { BsHouseAdd } from 'react-icons/bs';
import { FaLanguage, FaRegComments, FaUserFriends } from 'react-icons/fa';
import { IoCarOutline } from 'react-icons/io5';
import { MdAccountCircle, MdClose, MdHome, MdLogin, MdMenu, MdOutlineAppRegistration, MdOutlineEditCalendar, MdPublishedWithChanges } from 'react-icons/md';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../Button/Button';
import './Navbar.css'
import { useTranslation } from 'react-i18next';
import CustomModal from '../CustomModal';
import { BiCalendarCheck } from 'react-icons/bi';

const base_url = process.env.REACT_APP_BASE_URL

const Navbar = () => {
    const [searchParams] = useSearchParams();
    const participation_type = JSON.parse(localStorage.getItem("participation_type"));
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("token"));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const { t, i18n } = useTranslation();
    const handleLanguageChange = (e) => {
        const selectedLanguage = e.target.value;
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem("i18nextLng", selectedLanguage);
    };
    const storedLang = localStorage.getItem("i18nextLng") || 'cn';
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const navigate = useNavigate();
    const handleClick = () => { setClick(!click) };
    const closeMobileMenu = () => { setClick(false) };

    // dropdown for forms
    const [dropdown, setDropdown] = useState(false);
    const handleDropdownToggle = () => {
        if (window.innerWidth <= 768) {
            setDropdown(!dropdown);
        }
    };

    const logout = () => {
        localStorage.clear();
        window.location.reload();
    };
    const showButton = () => {
        if (window.innerWidth <= 768) {
            setButton(false);
        } else {
            setButton(true);
        }
    }
    const handleLanguageClick = () => {
        closeMobileMenu();
        toggleModal();
    }

    useEffect(() => {
        showButton();
        const selectedLanguage = searchParams.get("lang");

        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage);
            localStorage.setItem("i18nextLng", selectedLanguage);
            navigate(window.location.pathname, { replace: true });
        }
    }, []);

    window.addEventListener('resize', showButton);
    return (
        <>
            <CustomModal
                hideModal={toggleModal}
                open={isModalOpen}
                performAction={toggleModal}
                title="更換語言 Switch Language"
                children={
                    <select className="form-select" onChange={handleLanguageChange} value={storedLang}>
                        <option value="en">English</option>
                        <option value="cn">中文</option>
                    </select>
                }
            />
            <nav className='navbar shadow'>
                <div className="navbar-container">
                    <button
                        className="navbar-logo"
                        disabled={participation_type === null}
                        onClick={() => navigate(`${base_url}/`)}
                    >
                        <img src={`${base_url}/images/Shi-Ne-Ling-Logo.png`} alt="" />
                        <div>
                            <p className="mb-0 text-center"><strong>{t("navbar.homepage")}</strong></p>
                        </div>
                    </button>
                    <div className="menu-icon" onClick={handleClick}>
                        {click ? <MdClose className='fs-3' /> : <MdMenu className='fs-3' />}
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        {
                            // haven't login
                            participation_type == null
                                ?
                                <>
                                    <li className='nav-item'>
                                        <Link to={`${base_url}/course_registration`} className="nav-links" onClick={closeMobileMenu}>
                                            <MdOutlineAppRegistration className='fs-3' /> {t("navbar.courseRegistration")}
                                        </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                            <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                        </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to={`${base_url}/login`} className="nav-links-mobile" onClick={closeMobileMenu}>
                                            <MdLogin className='fs-3' /> {t("navbar.login")}
                                        </Link>
                                    </li>
                                </>
                                :
                                <>

                                    {participation_type === "Online" ? (
                                        <>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/online-personal-info`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdAccountCircle className='fs-3' /> {t("navbar.account")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${process.env.REACT_APP_CUSTOMER_SERVICE_LINK}${getTokenFromLocalStorage}`} target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <FaUserFriends className='fs-3' /> {t("navbar.chatbot")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/view_attendance`} className="nav-links" onClick={closeMobileMenu}>
                                                    <BiCalendarCheck className='fs-3' /> {t("navbar.attendance")}
                                                </Link>
                                            </li>
                                            {/* <li className='nav-item'>
                                                <Link to="https://www.shineling.org:3001/pre-retreat" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineEditCalendar className='fs-3' /> {t("navbar.preretreat")}
                                                </Link>
                                            </li> */}
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                                    <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link className="nav-links-mobile" onClick={() => { closeMobileMenu(); logout(); }}>
                                                    <MdLogin className='fs-3' /> {t("navbar.logout")}
                                                </Link>
                                            </li>
                                        </>
                                    ) : (
                                        // Regular student menu items - show all options
                                        <>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdHome className='fs-3' /> {t("navbar.homepage")}
                                                </Link>
                                            </li>
                                            <li
                                                className='nav-item dropdown-wrapper'
                                                onMouseEnter={() => window.innerWidth > 768 && setDropdown(true)}
                                                onMouseLeave={() => window.innerWidth > 768 && setDropdown(false)}
                                            >
                                                <div
                                                    className="nav-links dropdown-toggle"
                                                    onClick={handleDropdownToggle}
                                                >
                                                    <div className="d-flex align-items-center gap-2">
                                                        <MdAccountCircle className='fs-3' />
                                                        {t("navbar.form")}
                                                    </div>
                                                    <span className={`arrow-icon ${dropdown ? 'open' : ''}`}>▼</span>
                                                </div>

                                                <ul className={dropdown ? 'nav-submenu active' : 'nav-submenu'}>
                                                    <li>
                                                        <Link to={`${base_url}/view-personal-info`} className="submenu-item" onClick={closeMobileMenu}>
                                                            <MdAccountCircle /> {t("navbar.account")}
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${base_url}/view-accommodation`} className="submenu-item" onClick={closeMobileMenu}>
                                                            <BsHouseAdd /> {t("navbar.accomodation")}
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${base_url}/view-interview`} className="submenu-item" onClick={closeMobileMenu}>
                                                            <FaRegComments /> {t("navbar.interview")}
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${base_url}/view-transportation`} className="submenu-item" onClick={closeMobileMenu}>
                                                            <IoCarOutline /> {t("navbar.transportation")}
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${process.env.REACT_APP_CUSTOMER_SERVICE_LINK}${getTokenFromLocalStorage}`} target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <FaUserFriends className='fs-3' /> {t("navbar.chatbot")}
                                                </Link>
                                            </li>
                                            {/* <li className='nav-item'>
                                                <Link to="https://www.shineling.org:3001/pre-retreat" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineEditCalendar className='fs-3' /> {t("navbar.preretreat")}
                                                </Link>
                                            </li> */}
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                                    <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link className="nav-links-mobile" onClick={() => { closeMobileMenu(); logout(); }}>
                                                    <MdLogin className='fs-3' /> {t("navbar.logout")}
                                                </Link>
                                            </li>
                                        </>
                                    )}
                                </>
                        }
                    </ul>
                    <div className="d-flex justify-content-end">
                        <button className="language-icon" onClick={handleLanguageClick}><FaLanguage className='fs-3' /></button>
                        {button &&
                            <Button
                                // disabled={true}
                                onClick={participation_type === null ? () => navigate(`${base_url}/login`) : logout}
                                buttonStyle='btn--primary'>
                                {t(participation_type === null ? "navbar.login" : "navbar.logout")}
                            </Button>
                        }
                    </div>
                </div>

            </nav >
        </>
    )
}

export default Navbar